'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPage$() {
}
export { $c_Lpresto_RegisterPage$ as $c_Lpresto_RegisterPage$ };
$p = $c_Lpresto_RegisterPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPage$;
/** @constructor */
function $h_Lpresto_RegisterPage$() {
}
export { $h_Lpresto_RegisterPage$ as $h_Lpresto_RegisterPage$ };
$h_Lpresto_RegisterPage$.prototype = $p;
$p.dw = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1543548942);
});
$p.l = (function() {
  return "RegisterPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "RegisterPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_RegisterPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPage$, "presto.RegisterPage$", ({
  Qa: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_RegisterPage$ as $d_Lpresto_RegisterPage$ };
var $n_Lpresto_RegisterPage$;
function $m_Lpresto_RegisterPage$() {
  if ((!$n_Lpresto_RegisterPage$)) {
    $n_Lpresto_RegisterPage$ = new $c_Lpresto_RegisterPage$();
  }
  return $n_Lpresto_RegisterPage$;
}
export { $m_Lpresto_RegisterPage$ as $m_Lpresto_RegisterPage$ };
//# sourceMappingURL=presto.-Register-Page$.js.map
